module.exports = __webpack_public_path__ + "static/media/divinelogo.f3770a13.png";